module.exports = __webpack_public_path__ + "static/media/1-apm.e6601fb3.svg";